import {
	MONTHS_DAY_OPTIONS,
	timeOptions,
	timezoneOptions
} from '../../../helpers/SchedulingHelper';
import { MONTH_OPTIONS } from '../SchedulingSections.constants';

import { MONTH_SCHEDULING_LABELS } from './labels';
import { INPUT_TYPE, InputType } from './MonthlyScheduling.types';

const MonthsDayOptionsTransformed = MONTHS_DAY_OPTIONS.map((option) => ({
	...option,
	label: `Day ${option.label}`,
	value: option.value
}));

export const LastDayOfMonthOption = {
	label: MONTH_SCHEDULING_LABELS.lastDayOfMonth,
	value: 'lastDayOfMonthOption'
};

const DAYS_OF_MONTH_OPTIONS = [
	MonthsDayOptionsTransformed[0],
	LastDayOfMonthOption,
	...MonthsDayOptionsTransformed.slice(1)
];

export const INPUT_LIST: InputType[] = [
	{
		id: 'scheduling-day-of-month-select',
		type: INPUT_TYPE.SELECTED_DAY_OF_MONTH,
		label: MONTH_SCHEDULING_LABELS.daysOfMonthToRunScan,
		placeholder: MONTH_SCHEDULING_LABELS.daysOfMonthToRunScan,
		options: DAYS_OF_MONTH_OPTIONS,
		isSearchable: true,
		isMultiple: true
	},
	{
		id: 'scheduling-start-time-select',
		type: INPUT_TYPE.SELECTED_TIME,
		label: MONTH_SCHEDULING_LABELS.startTime,
		placeholder: MONTH_SCHEDULING_LABELS.startTime,
		options: timeOptions,
		isSearchable: true,
		isMultiple: false
	},
	{
		id: 'scheduling-timezone-select',
		type: INPUT_TYPE.SELECTED_TIMEZONE,
		label: MONTH_SCHEDULING_LABELS.timezone,
		placeholder: MONTH_SCHEDULING_LABELS.timezone,
		options: timezoneOptions,
		isSearchable: true,
		isMultiple: false
	},
	{
		id: 'scheduling-start-month-select',
		type: INPUT_TYPE.SELECTED_START_MONTH,
		label: MONTH_SCHEDULING_LABELS.startMonth,
		placeholder: MONTH_SCHEDULING_LABELS.startMonth,
		options: MONTH_OPTIONS,
		isSearchable: false,
		isMultiple: false
	}
];

export const MINIMUM_DAYS_TO_SHOW_WARNING = 29;
